import { theme } from 'styled-tools';
import styled from './styled.js';
import as from './as.js';
import Hidden from './Hidden.js';
import 'styled-components';
import './chunk-fb907809.js';
import '@emotion/is-prop-valid';
import 'react';
import 'hoist-non-react-statics';
import 'react-dom';
import 'prop-types';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';
import './chunk-d8771a86.js';
import './Box.js';
import './chunk-ac382c96.js';
import 'constate';
import './chunk-6133b9c9.js';

var Backdrop = styled(Hidden).withConfig({
  displayName: "Backdrop",
  componentId: "sc-1mc2k5c-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;z-index:998;-webkit-tap-highlight-color:rgba(0,0,0,0);-moz-tap-highlight-color:rgba(0,0,0,0);", ";"], theme("Backdrop"));
Backdrop.defaultProps = {
  role: "button",
  tabIndex: -1,
  opaque: true,
  palette: "shadow",
  tone: 2
};
var Backdrop$1 = as("div")(Backdrop);

export default Backdrop$1;
